export enum Manipulation {
  NONE = "NONE",
  ALS_ANDERE_FRAKTION_ZEIGEN = "ALS_ANDERE_FRAKTION_ZEIGEN",
  ALS_ANDERE_ROLLE_ZEIGEN = "ALS_ANDERE_ROLLE_ZEIGEN",
  ALS_ANDERE_KARTE_ZEIGEN = "ALS_ANDERE_KARTE_ZEIGEN",
  ASSIGN_CARD = "ASSIGN_CARD",
}
